module.exports = __webpack_public_path__ + "img/43222.d12abfdc.png";